/**
 * Mystery Slime Promo — Auto-add mystery slime to cart
 *
 * Flow:
 * 1. Customer lands on site via influencer link (e.g. /discount/CODE)
 * 2. Shopify sets the "discount_code" cookie and redirects to homepage
 * 3. Welcome popup appears with CTA buttons
 * 4. Once cart subtotal (excl. mystery slime) >= threshold, mystery slime is auto-added
 * 5. "FREE Mystery Slime" banner + title override while qualifying
 * 6. Shopify handles the 100% discount via native discount rules
 * 7. Promo expires after configurable number of days
 */

(function() {
  'use strict';

  var CONFIG = {
    enabled: true,
    variantId: '41781151858724',
    threshold: 4000,
    thresholdDisplay: '40',
    expirationDays: 2,
    codes: 'SIERRAPEACHY'
      .split(',')
      .map(function(c) { return c.trim().toLowerCase(); })
      .filter(function(c) { return c.length > 0; }),
    bundleProductUrl: '/products/bestsellers-slime-bundle'
  };

  if (!CONFIG.enabled || CONFIG.codes.length === 0 || !CONFIG.variantId) return;

  var EXPIRY_KEY = 'pb_mystery_slime_started';

  // ── Cookie helpers ──────────────────────────────

  function getDiscountFromCookie() {
    var match = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    return match ? decodeURIComponent(match[1]).toLowerCase().trim() : '';
  }

  function getDiscountCodeDisplay() {
    var match = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    return match ? decodeURIComponent(match[1]).trim() : '';
  }

  // ── Expiration logic ─────────────────────────────
  // Tracks when the promo was first activated. Expires after CONFIG.expirationDays.

  function isExpired() {
    if (CONFIG.expirationDays <= 0) return false; // 0 = never expires
    var started = localStorage.getItem(EXPIRY_KEY);
    if (!started) return false;
    var elapsed = Date.now() - parseInt(started, 10);
    var maxMs = CONFIG.expirationDays * 24 * 60 * 60 * 1000;
    return elapsed > maxMs;
  }

  function markPromoStarted() {
    if (!localStorage.getItem(EXPIRY_KEY)) {
      localStorage.setItem(EXPIRY_KEY, String(Date.now()));
    }
  }

  function clearPromoData() {
    localStorage.removeItem(EXPIRY_KEY);
    sessionStorage.removeItem('mystery_slime_popup_shown');
  }

  // ── Discount matching ────────────────────────────

  function isMatchingDiscount() {
    var code = getDiscountFromCookie();
    if (!code) return false;
    if (!CONFIG.codes.includes(code)) return false;

    // First time seeing a matching code — start the expiration timer
    markPromoStarted();

    // Check if expired
    if (isExpired()) {
      clearPromoData();
      return false;
    }

    return true;
  }

  // ── Cart item DOM helpers ────────────────────────

  function getMysterySlimeItem() {
    var cartItems = document.querySelectorAll('#CartDrawer .cart__item');
    for (var i = 0; i < cartItems.length; i++) {
      var key = cartItems[i].getAttribute('data-key') || '';
      if (key.startsWith(CONFIG.variantId)) return cartItems[i];
    }
    return null;
  }

  // ── Cart API helper ──────────────────────────────
  // Uses /cart.js for reliable cart state (avoids DOM timing issues)

  function getCartState() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      method: 'GET'
    }).then(function(res) { return res.json(); });
  }

  // ── Add / remove mystery slime ────────────────────

  var isUpdating = false;

  function removeMysterySlime(cart) {
    if (isUpdating) return;

    // Find the mystery slime line item key
    var slimeKey = null;
    for (var i = 0; i < cart.items.length; i++) {
      if (String(cart.items[i].variant_id) === CONFIG.variantId) {
        slimeKey = cart.items[i].key;
        break;
      }
    }
    if (!slimeKey) return;

    isUpdating = true;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: slimeKey, quantity: 0 })
    })
    .then(function(res) { return res.json(); })
    .then(function() {
      document.dispatchEvent(new CustomEvent('cart:build'));
    })
    .catch(function(err) { console.error('[Mystery Slime Promo] Error removing from cart:', err); })
    .finally(function() {
      isUpdating = false;
    });
  }

  function addMysterySlime() {
    if (isUpdating) return;
    isUpdating = true;

    // Double-check via API that the variant is not already in the cart
    getCartState().then(function(cart) {
      for (var i = 0; i < cart.items.length; i++) {
        if (String(cart.items[i].variant_id) === CONFIG.variantId) {
          // Already in cart — skip adding, just rebuild to update DOM
          isUpdating = false;
          document.dispatchEvent(new CustomEvent('cart:build'));
          return;
        }
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: parseInt(CONFIG.variantId),
            quantity: 1,
            properties: { '_mystery-slime-promo': 'true' }
          }]
        })
      })
      .then(function(res) { return res.json(); })
      .then(function() {
        document.dispatchEvent(new CustomEvent('cart:build'));
      })
      .catch(function(err) { console.error('[Mystery Slime Promo] Error adding to cart:', err); })
      .finally(function() {
        isUpdating = false;
      });
    }).catch(function() {
      isUpdating = false;
    });
  }

  // ── Promo banner ─────────────────────────────────

  function updatePromoBanner(isQualifying) {
    var item = getMysterySlimeItem();
    if (!item) return;

    var existingBanner = item.previousElementSibling;
    var hasBanner = existingBanner && existingBanner.classList.contains('mystery-slime-promo__banner');

    if (isQualifying) {
      if (!hasBanner) {
        var code = getDiscountCodeDisplay();
        var banner = document.createElement('div');
        banner.className = 'mystery-slime-promo__banner';
        banner.innerHTML = '🎉 <strong>FREE</strong> Mystery Slime – Code: <strong>' + code + '</strong>';
        item.parentNode.insertBefore(banner, item);
      }
    } else {
      if (hasBanner) {
        existingBanner.remove();
      }
    }
  }

  // ── Cart item title override ─────────────────────

  function overrideSlimeTitle(isQualifying) {
    var item = getMysterySlimeItem();
    if (!item) return;

    var nameEl = item.querySelector('.cart__item-name');
    if (!nameEl) return;

    var currentText = nameEl.textContent.trim();
    if (isQualifying) {
      if (currentText === 'Mystery Slime') {
        nameEl.textContent = 'FREE Mystery Slime';
      }
    } else {
      if (currentText === 'FREE Mystery Slime') {
        nameEl.textContent = 'Mystery Slime';
      }
    }
  }

  // ── Below-threshold message ──────────────────────

  function updateThresholdMessage(subtotalWithoutSlime) {
    var giftingBar = document.getElementById('pb05-gifting-bar');
    if (!giftingBar) return;

    var existingMsg = document.getElementById('mystery-slime-threshold-msg');
    var remaining = CONFIG.threshold - subtotalWithoutSlime;

    if (remaining > 0) {
      var dollars = (remaining / 100).toFixed(2).replace(/\.00$/, '');
      var html = "You're <strong>$" + dollars + "</strong> away from a <strong>FREE Mystery Slime!</strong>";

      if (existingMsg) {
        existingMsg.innerHTML = html;
        existingMsg.style.display = '';
      } else {
        var msg = document.createElement('div');
        msg.id = 'mystery-slime-threshold-msg';
        msg.className = 'mystery-slime-threshold-msg';
        msg.innerHTML = html;
        giftingBar.parentNode.insertBefore(msg, giftingBar.nextSibling);
      }
    } else {
      if (existingMsg) {
        existingMsg.style.display = 'none';
      }
    }
  }

  // ── Main check ───────────────────────────────────
  // Uses /cart.js API for subtotal calculation (reliable, not affected by
  // DOM timing or discount display), then updates DOM elements.

  var validateDebounce = null;

  function validateAndAdd() {
    // Debounce: multiple rapid cart:build:complete events → only run once
    clearTimeout(validateDebounce);
    validateDebounce = setTimeout(_validateAndAdd, 150);
  }

  function _validateAndAdd() {
    if (isUpdating) return;
    if (!isMatchingDiscount()) return;

    getCartState().then(function(cart) {
      var slimeInCart = false;
      var slimeLinePrice = 0;

      // Find mystery slime in the cart by variant ID
      for (var i = 0; i < cart.items.length; i++) {
        if (String(cart.items[i].variant_id) === CONFIG.variantId) {
          slimeInCart = true;
          slimeLinePrice = cart.items[i].final_line_price; // in cents, after discounts
          break;
        }
      }

      var subtotalWithoutSlime = cart.total_price - slimeLinePrice;
      var meetsThreshold = subtotalWithoutSlime >= CONFIG.threshold;

      // Update the below-threshold message in the DOM
      updateThresholdMessage(subtotalWithoutSlime);

      if (slimeInCart) {
        if (!meetsThreshold) {
          // Below threshold — remove the mystery slime
          removeMysterySlime(cart);
        } else {
          updatePromoBanner(meetsThreshold);
          overrideSlimeTitle(meetsThreshold);
        }
        return;
      }

      // Not in cart + meets threshold → add it
      if (meetsThreshold) {
        addMysterySlime();
      }
    }).catch(function(err) {
      console.error('[Mystery Slime Promo] Error fetching cart:', err);
    });
  }

  // ── Event listeners ──────────────────────────────

  document.addEventListener('cart:build:complete', validateAndAdd);

  document.addEventListener('cart:open', function() {
    setTimeout(validateAndAdd, 300);
  });

  // ── Welcome popup ────────────────────────────────

  function showPromoPopup() {
    if (!isMatchingDiscount()) return;

    var popupKey = 'mystery_slime_popup_shown';
    if (sessionStorage.getItem(popupKey)) return;
    sessionStorage.setItem(popupKey, '1');

    var code = getDiscountCodeDisplay().toUpperCase();
    renderPopup(code);
  }

  function renderPopup(code) {
    var overlay = document.createElement('div');
    overlay.className = 'mystery-slime-popup__overlay';

    var bundleImgSrc = 'https://cdn.shopify.com/s/files/1/2179/0939/files/BESTSELLER_SLIME_BUNDLE_UPDATE_d2532a0f-1174-4a5a-9e8c-174d863d122b.png?v=1755197685';

    overlay.innerHTML = ''
      + '<div class="mystery-slime-popup__modal">'
      +   '<button type="button" class="mystery-slime-popup__close" aria-label="Close">'
      +     '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 32 32" fill="none">'
      +       '<path d="M25.9 6.1L6.1 25.9" stroke="#282828" stroke-width="2.5" stroke-miterlimit="10" stroke-linecap="round"/>'
      +       '<path d="M25.9 25.9L6.1 6.1" stroke="#282828" stroke-width="2.5" stroke-miterlimit="10" stroke-linecap="round"/>'
      +     '</svg>'
      +   '</button>'
      +   '<div class="mystery-slime-popup__content">'
      +     '<h2 class="mystery-slime-popup__heading">Welcome!</h2>'
      +     '<p class="mystery-slime-popup__text">'
      +       'Thank you for coming here from <strong>' + code + '</strong>! '
      +       'They recommend our #1 bestseller bundle with all our most loved slimes. '
      +       'As a thank you from <strong>' + code + '</strong> and us, get a <strong>FREE mystery slime</strong> with any purchase of <strong>$' + CONFIG.thresholdDisplay + ' or above</strong>!'
      +     '</p>'
      +     '<div class="mystery-slime-popup__product-image">'
      +       '<img src="' + bundleImgSrc + '" alt="Bestseller Slime Bundle" loading="lazy">'
      +     '</div>'
      +     '<a href="' + CONFIG.bundleProductUrl + '" class="mystery-slime-popup__cta">Get our bestseller bundle</a>'
      +     '<a href="/collections/all" class="mystery-slime-popup__cta mystery-slime-popup__cta--secondary">Shop faves</a>'
      +   '</div>'
      + '</div>';

    document.body.appendChild(overlay);

    requestAnimationFrame(function() {
      overlay.classList.add('mystery-slime-popup--visible');
    });

    var closeBtn = overlay.querySelector('.mystery-slime-popup__close');
    closeBtn.addEventListener('click', function() { closePopup(overlay); });
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closePopup(overlay);
    });
  }

  function closePopup(overlay) {
    overlay.classList.remove('mystery-slime-popup--visible');
    setTimeout(function() { overlay.remove(); }, 300);
  }

  if (document.readyState === 'complete') {
    setTimeout(showPromoPopup, 1000);
  } else {
    window.addEventListener('load', function() {
      setTimeout(showPromoPopup, 1000);
    });
  }

})();
